export const getBrowserDisplay = (state: any) => state.browserdisplay;
export const getBrowserDisplayToggled = (state: any) => getBrowserDisplay(state).get('toggled');
export const getBrowserDisplayHTML = (state: any) => getBrowserDisplay(state).get('html');
export const getBrowserConsoleOutput = (state: any) => getBrowserDisplay(state).get('console');